export const Permanent = () => {
	return (
		<div className="permanent"></div>
	)
}